import { Fragment } from "react"
import {
  useDisclosure,
  Button,
  IconButton,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react"
import { DeleteIcon } from "@chakra-ui/icons"

const DeleteButton = ({ onClick, variant = "iconButton", ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <Fragment>
      {variant === "iconButton" ? (
        <IconButton
          colorScheme="red"
          variant="ghost"
          aria-label="Cancella"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation()
            onOpen()
          }}
          {...props}
        />
      ) : variant === "textButton" ? (
        <Button
          size="sm"
          colorScheme="red"
          onClick={(e) => {
            e.stopPropagation()
            onOpen()
          }}
        >
          Cancella
        </Button>
      ) : (
        <Button
          colorScheme="red"
          onClick={(e) => {
            e.stopPropagation()
            onOpen()
          }}
          {...props}
        >
          Cancella
        </Button>
      )}
      <Modal isOpen={isOpen} onClose={onClose} size="xs">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cancellare?</ModalHeader>
          <ModalFooter>
            <Stack direction="row" w="full">
              <Button flex="1" colorScheme="red" onClick={onClose}>
                No
              </Button>
              <Button flex="1" colorScheme="green" onClick={onClick}>
                Si
              </Button>
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

export default DeleteButton
